// src/components/Auth/AuthCallbackHandler.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // 💡 useTranslation 훅 임포트
import loadingStyles from './../../styles/Common.module.css';

function AuthCallbackHandler() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation(); // 💡 t 함수 사용

  useEffect(() => {
    // 비동기 작업을 시뮬레이션 (예: 인증 완료 대기)
    // 실제로는 인증 라이브러리의 Promise나 콜백을 사용할 수 있음
    const simulateAsyncOperation = async () => {
      try {
        await new Promise((resolve) => setTimeout(resolve, 1000)); // 1초 대기
        setLoading(false); // 로딩 완료
      } catch (error) {
        console.error('비동기 작업 중 오류:', error);
        setLoading(false); // 오류 발생 시에도 로딩 종료
      }
    };

    simulateAsyncOperation();
  }, []);

  useEffect(() => {
    if (!loading) {
      const redirectPath = sessionStorage.getItem('redirect_after_login');
      if (redirectPath) {
        sessionStorage.removeItem('redirect_after_login');
        console.log('Redirect path from sessionStorage:', redirectPath);
        navigate(redirectPath, { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    }
  }, [loading, navigate]);

  if (loading) {
    return (
      <div className={loadingStyles.loadingContainer}>
        <div className={loadingStyles.spinner}></div>
        {/* 💡 t 함수를 사용해 메시지 다국어 처리 */}
        <p>{t('auth.redirecting')}</p> 
      </div>
    );
  }
  return null;
}

export default AuthCallbackHandler;